/* eslint-disable consistent-return */
import React, { useState, useRef } from 'react';
import moment from 'moment-timezone';
import axios from 'axios';
import Loader from '../../Common/Loader';
import Filter from './Filter';
import { cookieStorageUtility } from '../../../utils/utilityFunctions';
import constants from '../../../constants';
import ReactPaginate from 'react-paginate';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const PushDataLogWrapper = () => {
  const [list, setList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [ota, setOta] = useState([]);
  const [showUILoader, setShowUILoader] = useState(false);
  const [categoHide, setCategoHide] = useState(1);
  const csvRef = useRef();
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageRangeDisplayed] = useState(5);
  const [counter, setCounter] = useState(0);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [showDetailPopup, setShowDetailPopup] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  // Safe moment initialization helper
  const getCurrentDate = () => {
    try {
      return moment(new Date()).format('L');
    } catch (error) {
      console.error('Date initialization error:', error);
      return new Date().toLocaleDateString();
    }
  };

  const [searchParam, setSearchParam] = useState({
    hotelId: '',
    channelId: '',
    status: 'all',
    requestType: 'all',
    searchBy: 'requested_date',
    fromDate: getCurrentDate(),
    toDate: getCurrentDate(),
    pmsCategoryId: ''
  });

  const setMessageFunc = (type, message) => {
    setFlag(true);
    setType(type);
    setMessage(message);
    setTimeout(() => setFlag(false), 3000);
  };

  const sendEmailLog = (log_id) => {
    if (!log_id) {
      setMessageFunc('error', 'Invalid log ID');
      return;
    }

    setShowUILoader(true);
    axios(serverUrl + 'logs/email_logs', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { log_id }
    }).then(response => {
      setShowUILoader(false);
      if (response.data.status === 'success') {
        setMessageFunc('success', response.data.message || 'Email sent successfully');
      } else {
        setMessageFunc('error', response.data.message || 'Failed to send email');
      }
    }).catch(error => {
      console.error('Email API Error:', error);
      setShowUILoader(false);
      setMessageFunc('error', 'Failed to send email. Please try again.');
    });
  };

  const showLogDetails = (logData) => {
    console.log('logData', logData);
    setSelectedLog(logData);
    setShowDetailPopup(true);
  };

  const closeDetailPopup = () => {
    setShowDetailPopup(false);
    setSelectedLog(null);
  };

  const searchLogs = () => {
    setShowUILoader(true);
    setList([]);
    setTotal(0);
    
    const requestPayload = {
      page: pageNumber,
      limit: limit,
      searchParam: searchParam
    };

    axios(serverUrl + 'logs/getpushdatalogs', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: requestPayload
    }).then(response => {
      // Validate response structure
      if (!response || !response.data) {
        throw new Error('Invalid response structure');
      }

      if (response.data.status === 'success') {
        // Ensure data is an array and validate structure
        let responseData = response.data.data;
        
        if (!Array.isArray(responseData)) {
          responseData = [];
        }

        // Validate each item in the array
        const validatedData = responseData.filter(item => {
          return item && typeof item === 'object';
        }).map(item => ({
          // Ensure all required fields exist with safe fallbacks
          _id: item._id || item.id || null,
          created_on: item.created_on || '',
          hotel_name: item.hotel_name || '',
          category_name: item.category_name || '',
          channel_name: item.channel_name || '',
          channel_category_name: item.channel_category_name || '',
          channel_rate_plan_name: item.channel_rate_plan_name || '',
          avail_date: item.avail_date || '',
          request_type: item.request_type || '',
          status: item.status || 'pending',
          error_message: item.error_message || '',
          amount: item.amount || '',
          avail_inventory: item.avail_inventory || '',
          min_los: item.min_los || '',
          ...item // Keep any additional properties
        }));

        setList(validatedData);
        setTotal(response.data.count || validatedData.length);
        
        if (validatedData.length === 0) {
          setMessageFunc('info', 'No logs found for the selected criteria');
        }
      } else {
        const errorMessage = response.data.message || 'Failed to fetch logs';
        setMessageFunc('error', errorMessage);
        setList([]);
        setTotal(0);
      }
      setShowUILoader(false);
    }).catch(error => {
      console.error('API Error:', error);
      let errorMessage = 'Network error occurred while fetching logs';
      
      if (error.response) {
        // Server responded with error status
        errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
      } else if (error.request) {
        // Request made but no response
        errorMessage = 'No response from server. Please check your connection.';
      } else {
        // Something else happened
        errorMessage = error.message || 'An unexpected error occurred';
      }
      
      setMessageFunc('error', errorMessage);
      setList([]);
      setTotal(0);
      setShowUILoader(false);
    });
  };

  const renderLogsList = () => {
    if (!Array.isArray(list) || list.length === 0) {
      return [];
    }

    return list.map((data, index) => {
      // Ensure data is a valid object
      if (!data || typeof data !== 'object') {
        return null;
      }

      // Safe string conversion function
      const safeString = (value) => {
        if (value === null || value === undefined) {
          return '';
        }
        return String(value);
      };

      // Format the update column based on request type
      const renderUpdateColumn = () => {
        const requestType = safeString(data.request_type);
        
        if (requestType === 'rate') {
          const amount = safeString(data.amount) || 'N/A';
          return <span>{`Room Price=${amount}`}</span>;
        } else if (requestType === 'inventory') {
          const availInventory = safeString(data.avail_inventory) || 'N/A';
          const minLos = safeString(data.min_los) || 'N/A';
          return (
            <div>
              <div>{`Allocation=${availInventory}`}</div>
              <div>{`MinLOS=${minLos}`}</div>
            </div>
          );
        } else {
          return <span>N/A</span>;
        }
      };

      // Format status with proper class
      const getStatusClass = (status) => {
        const statusStr = safeString(status).toLowerCase();
        if (statusStr === 'completed') return 'success';
        if (statusStr === 'error') return 'error';
        return 'pending';
      };

      // Generate a unique key
      const uniqueKey = data._id || data.id || `log-row-${index}-${Date.now()}`;

      return (
        <div className="table_row border_t_1 border_color_1" key={uniqueKey}>
          <div className="tabcel align_middle pad10">{safeString(data.created_on)}</div>
          <div className="tabcel align_middle pad10">{safeString(data.hotel_name)}</div>
          <div className="tabcel align_middle pad10">{safeString(data.category_name)}</div>
          <div className="tabcel align_middle pad10">{safeString(data.channel_name)}</div>
          <div className="tabcel align_middle pad10">{safeString(data.channel_category_name)}</div>
          <div className="tabcel align_middle pad10">{safeString(data.channel_rate_plan_name)}</div>
          <div className="tabcel align_middle pad10">{safeString(data.avail_date)}</div>
          <div className="tabcel align_middle pad10">
            {renderUpdateColumn()}
          </div>
          <div className="tabcel align_middle pad10">{safeString(data.request_type)}</div>
          <div className="tabcel align_middle pad10">
            <span>
              {data.status}
            </span>
          </div>
          <div className="tabcel align_middle pad10">{safeString(data.error_message)}</div>
          <div className="tabcel align_middle pad10">
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <i 
                className="fa fa-envelope cursor_p" 
                aria-hidden="true" 
                title="Send Email"
                onClick={() => sendEmailLog(data.thread_list_id)}
                style={{ color: '#007bff', fontSize: '16px' }}
              ></i>
              <i 
                className="fa fa-eye cursor_p" 
                aria-hidden="true" 
                title="View Details"
                onClick={() => showLogDetails(data)}
                style={{ color: '#28a745', fontSize: '16px' }}
              ></i>
            </div>
          </div>
        </div>
      );
    }).filter(Boolean); // Remove any null entries
  };
  
   // Handle page change
  const handlePageChange = (selectedPage) => {
    const newPageNumber = selectedPage.selected + 1; // ReactPaginate uses 0-based indexing
    const newCounter = newPageNumber <= 1 ? 0 : (newPageNumber - 1) * limit;
    
    setPageNumber(newPageNumber);
    setCounter(newCounter);
    
    // Call getActivityLogs after state is updated
    setTimeout(() => {
      searchLogs();
    }, 0);
  };

  const dateChange = (date, type) => {
    try {
      const newDate = moment(date).format('YYYY-MM-DD');
      const newSearch = { ...searchParam };
      newSearch[type] = newDate;
      
      const fromDate = moment(new Date(newSearch.fromDate));
      const toDate = moment(new Date(newSearch.toDate));
      
      if (fromDate.isValid() && toDate.isValid() && toDate.diff(fromDate, 'days') < 0) {
        newSearch['toDate'] = newDate;
      }
      
      setSearchParam(newSearch);
    } catch (error) {
      console.error('Date formatting error:', error);
      setMessageFunc('error', 'Invalid date format');
    }
  };

  const paramChange = (e, type) => {
    const newSearch = { ...searchParam };
    if (type === 'hotelName') {
      let hotelId = e.length > 0 ? e[0].hotel_id : '';
      newSearch[type] = e.length > 0 ? e[0].hotel : '';
      newSearch['hotelId'] = hotelId;
      getCategoryList(hotelId);
    } else {
      newSearch[type] = e.target.value;
    }
    setSearchParam(newSearch);
  };

  const typeheadInputChange = (selected, type) => {
    if (type === 'hotelName') {
      let newSearch = [...categoryList];
      if (newSearch.length > 0 && searchParam.hotelId === '') {
        newSearch = [];
        setCategoryList(newSearch);
      }
    }
  };

  const getCategoryList = (hotel) => {
    // Check if hotel is already a plain ID or needs to be decoded
    let hotelId;
    try {
      // Try to decode if it's base64 encoded
      hotelId = atob(hotel);
    } catch (e) {
      // If decoding fails, assume it's already a plain ID
      hotelId = hotel;
    }
    
    setShowUILoader(true);
    axios(serverUrl + 'category/roomcategorylist', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { hotelId }
    }).then(response => {
      if (response.data.status === 'success') {
        let categoryList = [];
        if (response.data.data && response.data.data.category_data && response.data.data.category_data.list) {
          response.data.data.category_data.list.forEach(val => {
            if (val.channel_details !== null) {
              const tempCategory = {
                room_category_id: val.room_category_id,
                room_category_name: val.room_category_name
              };
              categoryList.push(tempCategory);
            }
          });
        }
        setShowUILoader(false);
        setCategoHide(false);
        setCategoryList(categoryList);
      } else {
        setMessageFunc('error', response.data.message || 'Failed to fetch categories');
        setShowUILoader(false);
      }
    }).catch(error => {
      console.log(error);
      setMessageFunc('error', 'Network error occurred while fetching categories');
      setShowUILoader(false);
    });
  };

  const setOtaDetails = (channelIds) => {
    const newSearch = { ...searchParam };
    newSearch.channelId = channelIds;
    setSearchParam(newSearch);
  };

  const reset = () => {
    try {
      const currentDate = getCurrentDate();
      const newSearch = {
        hotelId: '',
        channelId: '',
        status: 'all',
        requestType: 'all',
        searchBy: 'requested_date',
        fromDate: currentDate,
        toDate: currentDate,
        pmsCategoryId: ''
      };
      setPageNumber(1);
      setCounter(0);
      setSearchParam(newSearch);
      setList([]);
      setTotal(0);
      setCategoryList([]);
      setCategoHide(true);
      // Don't call searchLogs automatically after reset
    } catch (error) {
      console.error('Reset function error:', error);
      setMessageFunc('error', 'Error occurred while resetting filters');
    }
  };

  return (
    <React.Fragment>
      {showUILoader && <Loader />}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Push Data Log</div>
          </div>
        </div>
      </div>
      {flag && (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>
          {message}
        </div>
      )}
      <Filter
        params={searchParam}
        dateChange={dateChange}
        paramChange={paramChange}
        searchLogs={searchLogs}
        setOtaDetails={setOtaDetails}
        reset={reset}
        categoryList={categoryList}
        categoHide={categoHide}
        typeheadInputChange={typeheadInputChange}
      />
      <div className="container_fluid pad_lft_rht20 padtop25 text-start">
        <div className="cover border_all_1 border_color_1">
          <div className="scrolly_auto">
            <div className="table_col table_fixed">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Requested Date</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Hotel Name</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Product</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Channel</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Room Type</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Rate Type</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Applied Date</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Update</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Request Type</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Status</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Description</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Action</div>
              </div>
              {renderLogsList()}
            </div>
          </div>
          {(!Array.isArray(list) || list.length === 0) && !showUILoader && (
            <div className="cover pad30 border_t_1 border_color_1">
              <div className="ovr tc marg_bottom10">
                <div className="inline"><img src="/images/no_result.png" alt="No Logs Found" /></div>
              </div>
              <div className="ovr tc fnt16 bld">No Logs Found</div>
            </div>
          )}
        </div>
        {total > limit && (
          <div className="cover tc margtop15">
            {/* <Pagination
              activePage={pageNumber}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={pageRangeDisplayed}
              onChange={handlePageChange}
            /> */}
            <ReactPaginate
              breakLabel="..."
              nextLabel="Next >"
              onPageChange={handlePageChange}
              pageRangeDisplayed={2}
              pageCount={Math.ceil(total / limit)}
              previousLabel="< Prev"
              forcePage={pageNumber - 1}
              containerClassName="pagination"
              activeClassName="active"
              marginPagesDisplayed={0}
            />
          </div>
        )}
      </div>

      {/* Detail Popup Modal */}
      {showDetailPopup && selectedLog && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            backdropFilter: 'blur(2px)'
          }}
          onClick={closeDetailPopup}
        >
          <div 
            onClick={(e) => e.stopPropagation()} 
            style={{ 
              backgroundColor: 'white',
              borderRadius: '12px',
              maxWidth: '900px',
              maxHeight: '90vh',
              overflow: 'hidden',
              width: '90%',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {/* Header */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '20px 25px',
            }}>
              <div>
                <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>Push Data Log Details</h3>
              </div>
              <i 
                className="fa fa-times" 
                onClick={closeDetailPopup}
                style={{ 
                  fontSize: '24px', 
                  cursor: 'pointer',
                  opacity: 0.9,
                  transition: 'opacity 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '1'}
                onMouseLeave={(e) => e.target.style.opacity = '0.9'}
              ></i>
            </div>

            {/* Body */}
            <div style={{ 
              padding: '25px', 
              overflowY: 'auto',
              flex: 1
            }}>
              {/* Hotel & Channel Information Section */}
              <div style={{ 
                marginBottom: '20px',
                padding: '18px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #e9ecef'
              }}>
                <h4 style={{ 
                  margin: '0 0 15px 0', 
                  fontSize: '16px', 
                  fontWeight: '600',
                  color: '#495057',
                  borderBottom: '2px solid #dee2e6',
                  paddingBottom: '8px'
                }}>
                  <i className="fa fa-building" style={{ marginRight: '8px', color: '#667eea' }}></i>
                  Hotel & Channel Information
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '12px' }}>
                  <div>
                    <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Hotel Name</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>
                      {selectedLog.hotel_name} 
                      {selectedLog.hotel_code && <span style={{ color: '#6c757d', fontSize: '13px' }}> ({selectedLog.hotel_code})</span>}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Hotel ID</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>{selectedLog.hotel_id}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Channel</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>
                      {selectedLog.channel_name} 
                      <span style={{ color: '#6c757d', fontSize: '13px' }}> (ID: {selectedLog.channel_id})</span>
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Channel Hotel ID</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>{selectedLog.channel_hotel_id}</div>
                  </div>
                </div>
              </div>

              {/* Room & Rate Plan Section */}
              <div style={{ 
                marginBottom: '20px',
                padding: '18px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #e9ecef'
              }}>
                <h4 style={{ 
                  margin: '0 0 15px 0', 
                  fontSize: '16px', 
                  fontWeight: '600',
                  color: '#495057',
                  borderBottom: '2px solid #dee2e6',
                  paddingBottom: '8px'
                }}>
                  <i className="fa fa-bed" style={{ marginRight: '8px', color: '#667eea' }}></i>
                  Room & Rate Plan Details
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '12px' }}>
                  <div>
                    <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Category</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>
                      {selectedLog.category_name} 
                      {selectedLog.category_name_code && <span style={{ color: '#6c757d', fontSize: '13px' }}> ({selectedLog.category_name_code})</span>}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Rate Plan</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>
                      {selectedLog.rateplan_name} 
                      {selectedLog.rateplan_code && <span style={{ color: '#6c757d', fontSize: '13px' }}> ({selectedLog.rateplan_code})</span>}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Channel Category</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>
                      {selectedLog.channel_category_name} 
                      {selectedLog.channel_category_id && <span style={{ color: '#6c757d', fontSize: '13px' }}> ({selectedLog.channel_category_id})</span>}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Channel Rate Plan</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>
                      {selectedLog.channel_rate_plan_name} 
                      {selectedLog.channel_rate_plan_id && <span style={{ color: '#6c757d', fontSize: '13px' }}> ({selectedLog.channel_rate_plan_id})</span>}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Mapping ID</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>{selectedLog.mapping_id}</div>
                  </div>
                </div>
              </div>

              {/* Date Information */}
              <div style={{ 
                marginBottom: '20px',
                padding: '18px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #e9ecef'
              }}>
                <h4 style={{ 
                  margin: '0 0 15px 0', 
                  fontSize: '16px', 
                  fontWeight: '600',
                  color: '#495057',
                  borderBottom: '2px solid #dee2e6',
                  paddingBottom: '8px'
                }}>
                  <i className="fa fa-calendar" style={{ marginRight: '8px', color: '#667eea' }}></i>
                  Date Information
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '12px' }}>
                  <div>
                    <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Available Date</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>{selectedLog.avail_date}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>Created On</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>{selectedLog.created_on}</div>
                  </div>
                </div>
              </div>

              {/* Rate Information - Only for rate requests */}
              {selectedLog.request_type === 'rate' && (
                <div style={{ 
                  marginBottom: '20px',
                  padding: '18px',
                  background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                  borderRadius: '8px',
                  border: '1px solid #dee2e6'
                }}>
                  <h4 style={{ 
                    margin: '0 0 15px 0', 
                    fontSize: '16px', 
                    fontWeight: '600',
                    color: '#495057',
                    borderBottom: '2px solid #dee2e6',
                    paddingBottom: '8px'
                  }}>
                    <i className="fa fa-money" style={{ marginRight: '8px', color: '#667eea' }}></i>
                    Pricing Details
                  </h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Final Amount</div>
                      <div style={{ fontSize: '18px', fontWeight: '700', color: '#28a745' }}>
                        {selectedLog.amount || 'N/A'}
                      </div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>System Price</div>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#212529' }}>{selectedLog.system_price || 'N/A'}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Derivative Price</div>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#212529' }}>{selectedLog.derivative_price || 'N/A'}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Derivative</div>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#212529' }}>{selectedLog.derivative || 'N/A'}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Mapping % Markup</div>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>{selectedLog.mapping_per_markup}%</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Mapping Flat Markup</div>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>{selectedLog.mapping_flat_markup || '0'}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Special % Markup</div>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>{selectedLog.special_per_markup}%</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Special Flat Markup</div>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>{selectedLog.special_flat_markup || '0'}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Threshold Rate</div>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>{selectedLog.mapping_threshold_rate || '0'}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Property Max Price</div>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#212529' }}>{selectedLog.property_max_price || '0'}</div>
                    </div>
                  </div>
                </div>
              )}

              {/* Inventory Information - Only for inventory requests */}
              {selectedLog.request_type === 'inventory' && (
                <div style={{ 
                  marginBottom: '20px',
                  padding: '18px',
                  background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                  borderRadius: '8px',
                  border: '1px solid #dee2e6'
                }}>
                  <h4 style={{ 
                    margin: '0 0 15px 0', 
                    fontSize: '16px', 
                    fontWeight: '600',
                    color: '#495057',
                    borderBottom: '2px solid #dee2e6',
                    paddingBottom: '8px'
                  }}>
                    <i className="fa fa-cubes" style={{ marginRight: '8px', color: '#667eea' }}></i>
                    Inventory Details
                  </h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Available Inventory</div>
                      <div style={{ fontSize: '18px', fontWeight: '700', color: '#007bff' }}>{selectedLog.avail_inventory || 'N/A'}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Min LOS</div>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#212529' }}>{selectedLog.min_los || 'N/A'}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', color: '#495057', marginBottom: '4px' }}>Max LOS</div>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#212529' }}>{selectedLog.max_los || 'N/A'}</div>
                    </div>
                  </div>
                </div>
              )}

              {/* Error Information */}
              {(selectedLog.error_message || selectedLog.error_code) && (
                <div style={{ 
                  marginBottom: '20px',
                  padding: '18px',
                  backgroundColor: '#fff3cd',
                  borderRadius: '8px',
                  border: '1px solid #ffc107',
                  borderLeft: '4px solid #ff6b6b'
                }}>
                  <h4 style={{ 
                    margin: '0 0 12px 0', 
                    fontSize: '16px', 
                    fontWeight: '600',
                    color: '#856404'
                  }}>
                    <i className="fa fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                    Error Details
                  </h4>
                  {selectedLog.error_code && (
                    <div style={{ marginBottom: '8px' }}>
                      <div style={{ fontSize: '12px', color: '#856404', marginBottom: '4px' }}>Error Code</div>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: '#721c24' }}>{selectedLog.error_code}</div>
                    </div>
                  )}
                  {selectedLog.error_message && (
                    <div>
                      <div style={{ fontSize: '12px', color: '#856404', marginBottom: '4px' }}>Error Message</div>
                      <div style={{ fontSize: '14px', color: '#721c24', lineHeight: '1.5' }}>{selectedLog.error_message}</div>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Footer */}
            <div style={{ 
              padding: '15px 25px', 
              borderTop: '2px solid #e9ecef',
              backgroundColor: '#f8f9fa',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px'
            }}>
              <button 
                onClick={closeDetailPopup}
                style={{ 
                  padding: '10px 24px',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#5a6268'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#6c757d'}
              >
                <i className="fa fa-times" style={{ marginRight: '6px' }}></i>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default PushDataLogWrapper;
